import { IApplicationState } from '../../types/redux';

/**
 * Выбирает состояние загрузки статей на Главной
 */
export const selectMainArticlesStatus = ({ mainArticles }: IApplicationState) => mainArticles.status;
